import { render, staticRenderFns } from "./ProjectDocumentTemplateDetailNew.vue?vue&type=template&id=36ea5809"
import script from "./ProjectDocumentTemplateDetailNew.vue?vue&type=script&lang=js"
export * from "./ProjectDocumentTemplateDetailNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports